export default "/wp-content/themes/onnit/script/cart/dist/tghBg-79100373.jpg";